import { useState, useCallback } from "react";

/**
 * Custom hook for clipboard operations with fallback support.
 * Handles browsers/contexts where clipboard API is restricted.
 * 
 * @param {number} resetDelay - Time in ms before resetting copied state (default: 2000)
 * @returns {{ copied: boolean, copyToClipboard: (text: string) => Promise<void> }}
 */
export function useClipboard(resetDelay = 2000) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = useCallback(async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), resetDelay);
    } catch {
      // Fallback: prompt for manual copy (clipboard permission denied in headless browsers, iframes, etc.)
      window.prompt("Copy this link:", text);
    }
  }, [resetDelay]);

  return { copied, copyToClipboard };
}

export default useClipboard;
